import { render } from "./updateDevice.vue?vue&type=template&id=5c2ad628&scoped=true"
import script from "./updateDevice.vue?vue&type=script&lang=js"
export * from "./updateDevice.vue?vue&type=script&lang=js"

import "./updateDevice.vue?vue&type=style&index=0&id=5c2ad628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2ad628"]])

export default __exports__